import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBellClock = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.4044 15.0901C16.5663 15.923 16.9061 16.7111 17.4005 17.4007H2.99927C2.99927 17.4007 4.19937 15.5373 4.19937 10.8001C4.19937 9.20868 4.83156 7.68242 5.95688 6.55711C7.08219 5.4318 8.60844 4.7996 10.1999 4.7996V2.99945"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3999 7.79952C11.3999 9.07267 11.9057 10.2937 12.8059 11.1939C13.7062 12.0942 14.9272 12.5999 16.2003 12.5999C17.4735 12.5999 18.6945 12.0942 19.5947 11.1939C20.495 10.2937 21.0007 9.07267 21.0007 7.79952C21.0007 6.52637 20.495 5.30537 19.5947 4.40512C18.6945 3.50487 17.4735 2.99911 16.2003 2.99911C14.9272 2.99911 13.7062 3.50487 12.8059 4.40512C11.9057 5.30537 11.3999 6.52637 11.3999 7.79952V7.79952Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2004 5.99936V8.99961H18.0006"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.59814 19.8005C8.69977 20.1467 8.91078 20.4507 9.1996 20.6669C9.48841 20.8831 9.83949 21 10.2003 21C10.5611 21 10.9121 20.8831 11.201 20.6669C11.4898 20.4507 11.7008 20.1467 11.8024 19.8005"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBellClock.displayName = 'SvgBellClock';
export default SvgBellClock;
